import { render, staticRenderFns } from "./TopTap.vue?vue&type=template&id=96f0aa26&scoped=true&"
import script from "./TopTap.vue?vue&type=script&lang=js&"
export * from "./TopTap.vue?vue&type=script&lang=js&"
import style0 from "./TopTap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f0aa26",
  null
  
)

export default component.exports